module.exports = __webpack_public_path__ + "assets/b71.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b71.png
// module id = 662
// module chunks = 0